import { Box, Divider, Flex, Link, Text, useDisclosure } from "@chakra-ui/react";
import GitcoinLogo from "../../../assets/gitcoinlogo-white.svg";
import { GrantCompletionBadge } from "./CompletionBadge";
import { renderToHTML } from "common/src/markdown";
import { MilestoneList } from "./MilestoneList";
import { ChevronDownIcon } from "@heroicons/react/24/outline";
import { ExpandableGrid } from "../../common/ExpandableGrid";
import { dateFromMs } from "../../api/utils";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const GrantItem = _ref => {
  let {
    grant,
    url
  } = _ref;
  const {
    isOpen,
    onToggle
  } = useDisclosure();
  const grantImageProps = {
    bg: "green.900",
    borderRadius: "full",
    height: 8,
    width: 8,
    bgImage: GitcoinLogo,
    bgRepeat: "no-repeat",
    bgPosition: "45% 40%",
    bgSize: "50%"
  };
  return /*#__PURE__*/_jsxs(Box, {
    children: [/*#__PURE__*/_jsxs(Box, {
      bg: "gray.50",
      borderRadius: 4,
      p: 5,
      children: [/*#__PURE__*/_jsxs(Flex, {
        justifyContent: "space-between",
        alignItems: "center",
        gap: 4,
        children: [/*#__PURE__*/_jsxs(Flex, {
          w: "full",
          alignItems: "center",
          justifyContent: "space-between",
          flexWrap: "wrap",
          children: [/*#__PURE__*/_jsx(Box, {
            children: /*#__PURE__*/_jsxs(Text, {
              fontWeight: "semibold",
              className: "flex gap-3",
              children: [/*#__PURE__*/_jsx(Box, {
                ...grantImageProps,
                className: "__grant-image"
              }), /*#__PURE__*/_jsx(Link, {
                href: url,
                target: "_blank",
                mt: 0.5,
                children: grant.title
              })]
            })
          }), /*#__PURE__*/_jsxs(Flex, {
            justify: "flex-end",
            gap: 5,
            children: [/*#__PURE__*/_jsx(Box, {
              children: /*#__PURE__*/_jsxs("small", {
                children: [/*#__PURE__*/_jsx("span", {
                  className: "hidden md:inline",
                  children: "Issued on: "
                }), dateFromMs(grant.createdAtMs)]
              })
            }), /*#__PURE__*/_jsx(GrantCompletionBadge, {
              completed: grant === null || grant === void 0 ? void 0 : grant.completed,
              milestones: grant.milestones
            })]
          })]
        }), /*#__PURE__*/_jsx(Box, {
          children: /*#__PURE__*/_jsx(ChevronDownIcon, {
            className: `cursor-pointer h-5 inline ${isOpen && "rotate-180"} transition-transform`,
            onClick: onToggle
          })
        })]
      }), /*#__PURE__*/_jsx(ExpandableGrid, {
        isOpen: isOpen,
        children: !!grant.description && /*#__PURE__*/_jsxs(Box, {
          overflow: "hidden",
          children: [/*#__PURE__*/_jsx(Divider, {
            borderWidth: 1,
            my: 4
          }), /*#__PURE__*/_jsx(Box, {
            __css: {
              h1: {
                fontSize: "1.5rem",
                fontWeight: "bold",
                margin: "1rem 0"
              },
              h2: {
                fontSize: "1.25rem",
                fontWeight: "bold",
                margin: "1rem 0"
              }
            },
            dangerouslySetInnerHTML: {
              __html: renderToHTML(grant.description)
            }
          })]
        })
      })]
    }), /*#__PURE__*/_jsx(ExpandableGrid, {
      classNames: "pt-4",
      isOpen: isOpen,
      children: /*#__PURE__*/_jsx(Box, {
        overflow: "hidden",
        children: grant.milestones.length > 0 && /*#__PURE__*/_jsx(MilestoneList, {
          milestones: grant.milestones
        })
      })
    }), grant.milestones.length === 0 && /*#__PURE__*/_jsxs(Text, {
      textAlign: "center",
      mb: 8,
      children: ["No updates are available for ", /*#__PURE__*/_jsx("b", {
        children: grant.title
      }), " currently. If you're the grant owner, you can post updates", " ", /*#__PURE__*/_jsx(Link, {
        color: "blue.400",
        target: "_blank",
        href: url,
        children: /*#__PURE__*/_jsx(Text, {
          as: "span",
          className: "text-gitcoin-violet-500",
          children: "here"
        })
      }), "."]
    })]
  });
};